import { useLang } from "../i18n";
import { useReveal } from "../hooks/useReveal";

export default function Process() {
  const { t } = useLang();
  const r = useReveal();

  return (
    <section id="process" data-testid="process-section" className="relative py-24 md:py-40">
      <div className="absolute inset-0 -z-0">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_rgba(244,208,63,0.07),_transparent_60%)]" />
      </div>
      <div className="relative container-x">
        <div ref={r} className="reveal max-w-3xl mb-14">
          <p className="overline mb-4">{t.process.overline}</p>
          <h2
            data-testid="process-title"
            className="font-display text-4xl sm:text-6xl lg:text-7xl uppercase tracking-tighter leading-[0.95]"
          >
            {t.process.title}
          </h2>
        </div>

        <ol className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-px bg-white/10">
          {t.process.steps.map((s, i) => {
            const accent = i % 2 === 0 ? "--mustard" : "--coral";
            return (
              <li
                key={i}
                data-testid={`process-step-${i}`}
                className="relative bg-black p-7 md:p-9 group hover:bg-neutral-950 transition-colors min-h-[260px] flex flex-col"
              >
                <div className="flex items-center gap-3">
                  <span className="w-1.5 h-1.5" style={{ background: `hsl(var(${accent}))` }} />
                  <span className="text-[10px] uppercase tracking-[0.28em] text-white/45">
                    Step
                  </span>
                </div>
                <div className="mt-4 font-display text-5xl md:text-6xl text-white/15 group-hover:text-white/30 transition-colors">
                  {s.n}
                </div>
                <h3 className="mt-4 font-display text-lg md:text-xl uppercase tracking-tight text-white">
                  {s.t}
                </h3>
                <p className="mt-3 text-sm text-white/65 leading-relaxed flex-1">{s.d}</p>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
